var React = require('react');

function StreamlineIconTicket (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"},React.createElement("path",{"d":"M23.2,10.53a1,1,0,0,0,.8-1V5.5A1.5,1.5,0,0,0,22.5,4H1.5A1.5,1.5,0,0,0,0,5.5V9.55a1,1,0,0,0,.8,1,1.5,1.5,0,0,1,0,2.94,1,1,0,0,0-.8,1V18.5A1.5,1.5,0,0,0,1.5,20h21A1.5,1.5,0,0,0,24,18.5V14.45a1,1,0,0,0-.8-1,1.5,1.5,0,0,1,0-2.94ZM5.25,18.25A.75.75,0,1,1,6,17.5.76.76,0,0,1,5.25,18.25Zm0-3.67A.75.75,0,1,1,6,13.83.75.75,0,0,1,5.25,14.58Zm0-3.66A.75.75,0,1,1,6,10.17.76.76,0,0,1,5.25,10.92Zm0-3.67A.75.75,0,1,1,6,6.5.76.76,0,0,1,5.25,7.25Zm11.75,9a1.75,1.75,0,1,1,1.75-1.75A1.75,1.75,0,0,1,17,16.25Zm1.5-7.5h-9a.75.75,0,0,1,0-1.5h9a.75.75,0,0,1,0,1.5Z"})));
}

StreamlineIconTicket.defaultProps = {"viewBox":"0 0 140 140"};

module.exports = StreamlineIconTicket;

StreamlineIconTicket.default = StreamlineIconTicket;
